import { AccountAccess } from '@treasury/domain/company/user/entities/access';
import { TmTableView } from '@treasury/presentation/components/jha-wc/tm-table';
import { deriveCountLabel, renderNoContent } from '@treasury/presentation/utils/table';

const SEARCH_PLACEHOLDER = 'Search by name, account, or CIF';

export function createAccessToView(
    onSelection: (selected: AccountAccess[]) => void
): TmTableView<AccountAccess> {
    return {
        label: deriveCountLabel('Access To'),
        reduceData: (event, incoming, current) => {
            const safeCurrent = current ?? [];
            const safeIncoming = incoming ?? [];
            return [...safeCurrent, ...safeIncoming].filter(
                account => account.hasPendingUserAccess ?? account.hasUserAccess
            );
        },
        searchPlaceholder: SEARCH_PLACEHOLDER,
        allowMultiSelect: true,
        filters: [
            {
                prop: 'accountType',
                type: 'single-selection',
            },
        ],
        columns: {
            canEdit: true,
            definitions: [
                { prop: 'accountName', label: 'Account name' },
                { prop: 'accountNumber', label: 'Account number' },
                { prop: 'cifNumber', label: 'CIF number' },
                { prop: 'accountType', label: 'Type', searchable: false },
            ],
        },
        selectActions: [
            {
                label: 'Remove accounts',
                execute: (selected: AccountAccess[]) => onSelection(selected),
            },
        ],
        noContentMessage: searchQuery => {
            const message =
                searchQuery === '' ? 'Add Available accounts' : '(0) Accounts match your search';
            return renderNoContent(message);
        },
    };
}

export function createAvailableView(
    onSelection: (selected: AccountAccess[]) => void
): TmTableView<AccountAccess> {
    return {
        label: deriveCountLabel('Available'),
        reduceData: (event, incoming, current) => {
            const safeCurrent = current ?? [];
            const safeIncoming = incoming ?? [];
            return [...safeCurrent, ...safeIncoming].filter(
                account => !account.hasPendingUserAccess
            );
        },
        searchPlaceholder: SEARCH_PLACEHOLDER,
        allowMultiSelect: true,
        filters: [
            {
                prop: 'accountType',
                type: 'single-selection',
            },
        ],
        columns: {
            canEdit: true,
            definitions: [
                { prop: 'accountName', label: 'Account name' },
                { prop: 'accountNumber', label: 'Account number' },
                { prop: 'cifNumber', label: 'CIF number' },
                { prop: 'accountType', label: 'Type', searchable: false },
            ],
        },
        selectActions: [
            {
                label: 'Add accounts',
                execute: (selected: AccountAccess[]) => onSelection(selected),
            },
        ],
        noContentMessage: searchQuery => {
            const message =
                searchQuery === '' ? 'No Available accounts' : '(0) Accounts match your search';
            return renderNoContent(message);
        },
    };
}
